export default __webpack_public_path__ + "static/media/favicon.e20fff44.png";